/**
 * @generated SignedSource<<57b5f7e8d373b95da37469fc4751a62d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSummaryItemSkuDetails_transaction$data = {
  readonly sku: {
    readonly leadTime: string | null;
  } | null;
  readonly skuVariableAttributeRows: ReadonlyArray<{
    readonly label: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"RingSizeDisplay_transaction">;
  readonly " $fragmentType": "CheckoutSummaryItemSkuDetails_transaction";
};
export type CheckoutSummaryItemSkuDetails_transaction$key = {
  readonly " $data"?: CheckoutSummaryItemSkuDetails_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSummaryItemSkuDetails_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RingSizeDisplay_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeRow",
      "kind": "LinkedField",
      "name": "skuVariableAttributeRows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "Checkout"
            }
          ],
          "kind": "ScalarField",
          "name": "leadTime",
          "storageKey": "leadTime(pageType:\"Checkout\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "14be481aad70e8064f3cc2f109c6f1be";

export default node;
